import { LayerProps } from 'react-map-gl'
import { PointIcons } from './custom-layer'
import { Feature } from 'models/map'

export enum GeometryTypes {
  Point = 'Point',
  Polygon = 'Polygon',
  Line = 'Line',
}

export enum LayerGroupTypes {
  PREDICTIVE_MODEL = 'predictive_model',
  PREMIUM = 'premium',
}

export type LayerGroup = {
  name: string
  icon: string
  type?: LayerGroupTypes
  predictiveModelId?: string
  layers: Layer[]
}

export type Layer = {
  id: number
  name: string
  description: string
  geometryType: GeometryTypes
  style: {
    icon: PointIcons
    color: string
    strokeWith?: number
  }

  downloadable?: boolean

  file?: LayerFile

  viz: LayerProps & {
    'source-layer': string
  }
  editable?: boolean
  fields?: LayerFields[]

  idlayerlabels?: number
}


export type LayerFile = {
  name: string
  url: string
}

export type LayerFields = {
  name: string
  type: 'text' | 'textarea' | 'select'
  key: string
  options?: string[]
}

export type AddFeatureParams = {
  feature: Feature
  data: FeatureMetaParams
}

export type UpdateFeatureParams = {
  data: FeatureMetaParams
}

export type FeatureMetaParams = {
  [key: string]: string | number
}
